export default {
  title_one: 'Usage unique, {{discount}}',
  title_other: '{{count}} utilisations, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} de remise totale',
    percentage_discount: 'Remise en pourcentage',
  },
  buttons: {
    add_component: 'Ajouter une utilisation',
  },
};
